module.exports = __webpack_public_path__ + "img/check.f39fb297.svg";